import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { DossierId } from '../dossier/types';

import { getTestimonial } from './api';
import { Testimonial } from './types';

export const getTestimonialQueryKey = (dossierId: DossierId) => ['testimonial', dossierId];

export const useGetTestimonial = (
    dossierId: DossierId,
    options?: Omit<UseQueryOptions<Testimonial, Error>, 'queryKey' | 'queryFn'>,
) => {
    return useQuery({
        queryKey: getTestimonialQueryKey(dossierId),
        queryFn: () => getTestimonial(dossierId),
        enabled: !!dossierId,
        ...options,
    });
};
